import { getAdminAuthHeaders, handleAdminUnauthorized } from '../auth/adminSession';
const API_BASE = String(process.env.REACT_APP_ADMIN_API_BASE_URL || process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3100' : '')).replace(/\/$/, '');
const BASE = `${API_BASE}/admin/permissions/lounge`;

async function request(path = '', { method = 'GET', body, signal } = {}) {
  const url = `${BASE}${path}`;
  const res = await fetch(url, {
    method, credentials: 'include',
    headers: { ...getAdminAuthHeaders(), ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}) },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}), signal,
  });
  handleAdminUnauthorized(res.status, url);
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) {
    const error = new Error(json.message || `HTTP ${res.status}`);
    error.status = res.status;
    throw error;
  }
  return json;
}
export const fetchMyLoungePermissions = (signal) => request('/me', { signal });
export const fetchLoungePermissionSettings = (signal) => request('', { signal });
export const updateLoungeLevelPermission = (level, permissions, reason) => request(`/levels/${level}`, { method: 'PUT', body: { permissions, reason } });
export const searchAdminPermissionAccounts = (q, signal) => request(`/accounts/search?q=${encodeURIComponent(q)}`, { signal });
export const fetchLoungeAccountPermission = (code, signal) => request(`/accounts/${encodeURIComponent(code)}`, { signal });
export const updateLoungeAccountPermission = (code, permissions, reason) => request(`/accounts/${encodeURIComponent(code)}`, { method: 'PUT', body: { permissions, reason } });
